<template>

  <section class="loginWrapper">
    <img src="@/assets/jhl-logo.png" class="logo" alt="JHL logo" />

    <form class="loginForm" autocomplete="new-password">

      <h1>Kirjaudu sisään</h1>

      <input autocomplete="new-password" type="text" v-model="email" placeholder="matti.meikalainen@interweb.com" />
      <input autocomplete="new-password" type="password" v-model="password" placeholder="Salasana" />
      <button class="loginButton" @click.prevent="login()">Kirjaudu sisään</button>

    </form>

  </section>

</template>

<script>
import "@/helpers/firebaseConf"
import firebase from "firebase/app";
import "firebase/auth";

export default {
  data() {
    return {
      email: "",
      password: "",
      errorMessage: null,
    }
  },
  methods: {

    login() {
      var self = this;

      firebase.auth().signInWithEmailAndPassword(self.email, self.password).then(function() {

        self.$router.push({ path: "/" }).catch(() => {})

      }).catch(function(error) {
        if( error.code == "auth/user-not-found" ) self.errorMessage = "No account found — please check your email.";
        if( error.code == "auth/invalid-email" ) self.errorMessage = "Please check your email format.";
        if( error.code == "auth/wrong-password" ) self.errorMessage = "Password doesn't match with this email — please check your password";
      });

    }

  }
}
</script>

<style lang="scss" scoped>

.loginWrapper {
  width: 100%;
  height: 380px;
  background: url('../assets/pisarat-turqoise.svg') top left;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);

  .logo {
    width: auto;
    display: block;
    height: 70px;
    position: absolute;
    left: 50%;
    top: -90px;
    transform: translate(-50%, 0);
  }

  .loginForm {
    position: absolute;
    width: 95%;
    max-width: 480px;
    left: 50%;
    transform: translate(-50%, 0);
    top: 30px;
    bottom: 30px;
    background: white;
    padding: 30px;

    h1 {
      font-size: 28px;
      width: 100%;
      margin: 0 0 20px 0;
      padding: 0;
      font-weight: 700;
      text-align: center;
    }

    input {
      text-align: center;
      margin: 0 0 15px 0;
    }

    .loginButton {
      width: 100%;
      background: #d41c3d;
      height: 48px;
      color: white;
      border-radius: 4px;
    }

  }

}

</style>
